export function queuedByGenderColumn({ t, lang }) {
  const currentYear = new Date().getFullYear();
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      maxWidth: 60,
      filterable: false,
      style: { textAlign: 'center' }
    },
    {
      Header: t('monitoring_columnLocation'),
      accessor: `${lang}_locationName`,
      filterable: false
    },
    {
      Header: `${currentYear - 6} ${t('age_male')}`,
      accessor: `year_6_male`,
      filterable: false
    },
    {
      Header: `${currentYear - 6} ${t('age_female')}`,
      accessor: `year_6_female`,
      filterable: false
    },
    {
      Header: `${currentYear - 5} ${t('age_male')}`,
      accessor: `year_5_male`,
      filterable: false
    },
    {
      Header: `${currentYear - 5} ${t('age_female')}`,
      accessor: `year_5_female`,
      filterable: false
    },
    {
      Header: `${currentYear - 4} ${t('age_male')}`,
      accessor: `year_4_male`,
      filterable: false
    },
    {
      Header: `${currentYear - 4} ${t('age_female')}`,
      accessor: `year_4_female`,
      filterable: false
    },
    {
      Header: `${currentYear - 3} ${t('age_male')}`,
      accessor: `year_3_male`,
      filterable: false
    },
    {
      Header: `${currentYear - 3} ${t('age_female')}`,
      accessor: `year_3_female`,
      filterable: false
    },
    {
      Header: `${currentYear - 2} ${t('age_male')}`,
      accessor: `year_2_male`,
      filterable: false
    },
    {
      Header: `${currentYear - 2} ${t('age_female')}`,
      accessor: `year_2_female`,
      filterable: false
    },
    {
      Header: `${currentYear - 1} ${t('age_male')}`,
      accessor: `year_1_male`,
      filterable: false
    },
    {
      Header: `${currentYear - 1} ${t('age_female')}`,
      accessor: `year_1_female`,
      filterable: false
    },
    {
      Header: `${currentYear} ${t('age_male')}`,
      accessor: `year_0_male`,
      filterable: false
    },
    {
      Header: `${currentYear} ${t('age_female')}`,
      accessor: `year_0_female`,
      filterable: false
    },
    {
      Header: t('from_2_to_6'),
      accessor: `from_2_to_6`,
      filterable: false
    },
    {
      Header: t('from_3_to_6'),
      accessor: `from_3_to_6`,
      filterable: false
    }
  ];
}
